import api from '@pray/shared/utils/api';

import type { WorkflowResponse } from './data/response';
import type { CreateWorkflowRequest } from './data/types';

type CreateWorkflowProps = {
  artistId: string;
  data: CreateWorkflowRequest;
};

export async function createWorkflow({ artistId, data }: CreateWorkflowProps): Promise<WorkflowResponse> {
  if (!artistId) throw new Error('Artist ID is required');
  if (!data.name) throw new Error('Workflow name is required');

  const url = `/web/studio/artists/${artistId}/workflows`;

  const response = await api.executePostRequest<WorkflowResponse>(url, data);
  return response.data;
}
